import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QConfigGeneratorList } from '@exam-management/qconfig-generator-list';
import { useNavigate, useParams } from '@exam-management/router';
import { Flex, PaperSection, Button, AddRoundedIcon } from '@shared/components';
import { WithPermission } from '@shared/permissions';
export default function QConfigGeneratorsPage() {
  const { courseId } = useParams('/exam-courses/:courseId/qconfig-generators');
  const navigate = useNavigate();
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        width: '100%',
        p: theme.spacing(6),
        minHeight: 'fit-content',
        height: '100dvh',
      })}
    >
      <Flex sx={{ flexGrow: 1 }}>
        <PaperSection
          title='QConfig Generator'
          endAdornment={
            <WithPermission requiredPermission={APP_PERMISSIONS.EXAM.QCONFIG.CREATE}>
              <Button
                variant='contained'
                startIcon={<AddRoundedIcon />}
                onClick={() =>
                  navigate('/exam-courses/:courseId/qconfig-generators/create', {
                    params: { courseId },
                  })
                }
              >
                Gen QConfig
              </Button>
            </WithPermission>
          }
        >
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              height: '100%',
              gap: theme.spacing(6),
              p: theme.spacing(6),
            })}
          >
            <QConfigGeneratorList />
          </Flex>
        </PaperSection>
      </Flex>
    </Flex>
  );
}
